<template>
  <div>
    <top-message />
    <div class="content">
      <div class="titlePart">历史记录</div>
      <div v-if="$store.state.review.isList">
        <div class="applyTime">
          <el-form
            :inline="true"
            :model="searchForm"
            class="demo-form-inline"
            style="border-bottom: 1px solid #F3F4F9;padding: 0 30px"
          >
            <el-form-item label="申请开始时间">
              <div class="block">
                <!-- <el-date-picker
                  @change="query()"
                  style="width: 180px"
                  v-model="searchForm.applyTimes"
                  type="monthrange"
                  range-separator="至"
                  start-placeholder="开始"
                  end-placeholder="结束"
                  value-format="yyyy-MM"
                ></el-date-picker> -->
                <el-date-picker
                  :editable="false"
                  v-model="searchForm.startTime"
                  :picker-options="startDatePicker"
                  type="month"
                  value-format="yyyy-MM"
                  format="yyyy-MM"
                  placeholder="选择开始日期"
                  @change='handleTimeChange'
                />
              </div>
            </el-form-item>
            <el-form-item
              label="申请结束时间"
              prop="endTime"
            >
              <el-date-picker
                :editable="false"
                v-model="searchForm.endTime"
                :picker-options="endDatePicker"
                type="month"
                value-format="yyyy-MM"
                format="yyyy-MM"
                placeholder="选择结束日期"
                @change='handleTimeChange'
              />
            </el-form-item>
            <el-form-item label="审核状态">
              <el-select
                @change="query()"
                v-model="searchForm.applyStatus"
                placeholder="请选择"
                style="width: 160px"
                clearable
              >
                <el-option
                  v-for="item in statusOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>

            <!-- <el-form-item label="授权对象">
              <el-select
                @change="query()"
                v-model="searchForm.applyBank"
                placeholder="请选择"
                style="width: 160px"
                clearable
              >
                <el-option
                  v-for="item in bankOption"
                  :key="item.bankCode "
                  :label="item.bankName"
                  :value="item.bankCode"
                ></el-option>
              </el-select>
            </el-form-item> -->
          </el-form>
        </div>
        <div
          class="details"
          v-for="(item,index) in auditList"
          :key="index"
        >
          <div class="detailsBox">
            <div class="text">
              <div class="textTitle">企业征信信息采集和查询授权书</div>
              <div class="textBtn">授权对象：{{ item.bankName }}</div>
            </div>
            <div class="rightPart">
              <el-steps
                :active="0"
                align-center
              >
                <el-step
                  title="申请"
                  :description="item.creteTime && $moment(item.creteTime).format('YYYY-MM-DD HH:mm:ss')"
                  :status="getStatus(1)"
                />
                <el-step
                  v-if="item.examineStatus==='0'"
                  :status="getStatus(0)"
                  title="待审核"
                />
                <el-step
                  v-if="item.examineStatus==='1'"
                  title="审核通过"
                  :description="item.examineTime===null?'':$moment(item.examineTime).format('YYYY-MM-DD HH:mm:ss')"
                  :status="getStatus(1)"
                />
                <el-step
                  v-if="item.examineStatus==='2'"
                  title="审核不通过"
                  :description="item.examineTime===null?'':$moment(item.examineTime).format('YYYY-MM-DD HH:mm:ss')"
                  :status="getStatus(2)"
                />
              </el-steps>
            </div>
            <div class="buttom">
              <el-button
                type="primary"
                @click="viewDetails(index,item.examineStatus,item.examineTime)"
              >查看详情</el-button>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="audit">
          <div class="text">
            <div class="textTitle">企业征信信息采集和查询授权书</div>
            <div class="textBtn">授权对象：{{ detailsList[0].enterpriseName }}</div>
          </div>
          <div class="rightPart">
            <el-steps align-center>
              <el-step
                title="申请"
                :status="getStatus(1)"
                :description="detailsList[0].creteTime && $moment(detailsList[0].creteTime).format('YYYY-MM-DD HH:mm:ss')"
              />
              <el-step
                v-if="detailsList[0].examineStatus==='0'"
                :status="getStatus(0)"
                title="待审核"
              />
              <el-step
                v-if="detailsList[0].examineStatus==='1'"
                :status="getStatus(1)"
                title="审核通过"
                :description="examineTime"
              />
              <el-step
                v-if="detailsList[0].examineStatus==='2'"
                :status="getStatus(2)"
                title="审核不通过"
                :description="examineTime"
              />
            </el-steps>
          </div>
        </div>
        <div class="auditDetails">
          <div class="leftBox">
            <div>
              <div>授权对象</div>
              <el-input
                style="margin-top:7px;"
                v-model="AuthorizationObj"
                :disabled="true"
              ></el-input>
            </div>
            <div style="
                margin-top:27px;">
              <div>基本开户行</div>
              <el-input
                style="margin-top:7px;"
                v-model="openingBank"
                :disabled="true"
              ></el-input>
            </div>
            <div style="margin-top:27px;">
              <div>经营执照</div>
              <show-image
                class="imgSize"
                :image-url=" this.detailsList[0].businessLicenseUrl"
              />
            </div>
          </div>

          <div class="rightBox">
            <div>
              <div>经办人姓名</div>
              <el-input
                style="margin-top:7px;"
                v-model="AttentioLine"
                :disabled="true"
              ></el-input>
            </div>
            <div
              style="display:flex;justify-content: space-between;margin-top:15px"
            >
              <show-image
                class="imgSizeid"
                :image-url="  this.detailsList[0].operatorIdFrontUrl"
                style="margin-right:10px;"
              />
              <show-image
                class="imgSizeid"
                :image-url="  this.detailsList[0].operatorIdBackUrl"
              />

            </div>
            <div style="margin-top:10px">
              <div>授权书</div>
              <show-image
                class="imgSize"
                :image-url="  this.detailsList[0].authUrl"
              />
            </div>
          </div>
        </div>

        <div
          class="auditBtn"
          v-if="show"
        >
          <div
            style="border-left: 5px solid #F85B4B; padding-left:20px;height: 20px;"
          >审核建议 </div>
          <div style="margin-top:19px">*{{ this.detailsList[0].examineReason }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryAuth, getBankList } from "@/api/myCenter"
import ShowImage from "../ShowImage";
import TopMessage from "@/components/TopMessage";
export default {
  components: { ShowImage, TopMessage },
  data () {
    return {
      searchForm: {
        companyName: "",
        startTime: '',
        endTime: '',
        applyBank: "",
        applyStatus: "",
      },
      statusOption: [
        { value: 0, label: "未审核" },
        { value: 1, label: "审核通过" },
        { value: 2, label: "审核不通过" },
      ],
      bankOption: [],
      active: 2,
      startTime: "",
      endTime: "",
      auditList: [],
      detailsList: [],
      AuthorizationObj: '',
      AttentioLine: '',
      openingBank: '',
      show: false,
      operatorIdFrontUrlList: [],
      examineTime: '',
      startDatePicker: this.beginDate(),
      endDatePicker: this.processDate(),
    }
  },
  created () {
    this.$store.commit("setIsList", true);
    // this.getBankList()
    this.query()
  },
  methods: {
    beginDate () {
      const self = this;
      return {
        disabledDate (time) {
          if (self.searchForm.endTime) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.searchForm.endTime).getTime() < time.getTime();
          } else {
            // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
          }
        }
      };
    },
    processDate () {
      const self = this;
      return {
        disabledDate (time) {
          if (self.searchForm.startTime) {
            //如果开始时间不为空，则结束时间大于开始时间
            return new Date(self.searchForm.startTime).getTime() > time.getTime();
          } else {
            // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
          }
        }
      }
    },
    handleTimeChange () {
      this.query()
    },
    query (e) {
      // if (this.searchForm.applyTimes == null) {
      //   this.searchForm.applyTimes = ''
      // }
      // let bankCode = '',
      //   examineStatus = '',
      //   startTime = '',
      //   endTime = ''
      const params = {
        bankCode: this.searchForm.applyBank,
        examineStatus: this.searchForm.applyStatus,
        startTime: this.searchForm.startTime,
        endTime: this.searchForm.endTime
      };
      queryAuth(this.sendParam(params)).then(res => {
        res = this.paramDecrypt(res);
        if (res.code === 202) {
          this.$message.error(res.msg);
        } else if (res.code === 203) {
          this.$message.error('用户未登录');
        }
        this.auditList = res.data
      })
    },
    getBankList () {
      const params = this.sendParam({ timeStamp: new Date().getTime() });
      getBankList(params).then(res => {
        res = this.paramDecrypt(res);
        this.bankOption = res.data
      })
    },
    viewDetails (index, examineStatus, examineTime) {
      this.detailsList = []
      this.detailsList.push(this.auditList[index])
      this.$store.commit("setIsList", false);
      this.AuthorizationObj = this.detailsList[0].enterpriseName
      this.AttentioLine = this.detailsList[0].operatorName
      this.openingBank = this.detailsList[0].bankName
      this.operatorIdFrontUrlList.push(this.detailsList[0].operatorIdFrontUrl)
      if (examineTime !== null) {
        this.examineTime = this.detailsList[0].examineTime && this.$moment(this.detailsList[0].examineTime).format("YYYY-MM-DD HH:mm:ss");
      }
      this.show = examineStatus === '2';
    },
    getStatus (index) {
      let index1 = Number(index)
      let status = "process";
      if (index1 === 0) {
        status = "wait";
      } else if (index1 === 1) {
        status = "finish";
      } else if (index1 === 2) {
        status = "error";
      }
      return status;
    },
  }
}
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  min-height: 787px;
  background: #fff;
  box-sizing: border-box;
  padding-top: 20px;
  font-size: 14px;
  border-radius: 6px;
  margin-top: 20px;

  .titlePart {
    color: #2981ee;
    font-size: 24px;
    font-weight: bold;
    border-left: 5px solid #2981ee;
    padding-left: 20px;
    margin-bottom: 20px;
  }

  .applyTime {
    width: 100%;
  }

  .details {
    width: 100%;
    //height: 113px;
    padding: 0 25px;
    box-sizing: border-box;

    .detailsBox {
      padding: 20px 0;
      height: 100%;
      border-bottom: 1px solid #f3f4f9;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .textTitle {
        font-size: 20px;
        font-family: Alibaba PuHuiTi;
        font-weight: bold;
        color: #2a2a2a;
      }

      .textBtn {
        font-size: 16px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: #252525;
        margin-top: 14px;
      }
    }

    .rightPart {
      width: 33%;
    }

    /deep/ .el-steps {
      .el-step__line-inner {
        border-color: #dbdbdb;
      }

      .el-step__icon {
        color: #fff;
        top: -5px;
        border-width: 5px;
        box-sizing: content-box;
      }

      .is-finish .el-step__icon {
        background: #3bc37b;
        border-color: #bcecd2;
      }

      .is-process .el-step__icon {
        background: #2981ee;
        border-color: #abc9ef;
      }

      .is-wait .el-step__icon {
        background: #a7a7a7;
        border-color: #dbdbdb;
      }

      .el-step__title {
        font-size: 16px;
        font-weight: 540;
      }

      .is-error .el-step__icon {
        background: #f85b4b;
        border-color: #f2c8c3;
      }

      .el-step__title.is-finish {
        //color: #c0c4cc;
        color: #44cb8e;
      }

      .el-step__title.is-process {
        //color: #a7a7a7;
        color: #3498f2;
      }

      .el-step__title.is-wait {
        color: #a7a7a7;
      }

      .el-step__description {
        padding-left: 10px !important;
        padding-right: 10px !important;
        color: #252525;
      }

      .cancelButton {
        color: #fff;
        font-size: 13px;
        padding: 4px 6px;
        background: #2981ee;
        border-radius: 4px;
        width: 30px;
        margin: 4px auto 0;
        cursor: pointer;
      }

      .rejectSpan {
        color: #f85b4b;
      }
    }
  }

  .audit {
    width: 100%;
    height: 120px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f3f4f9;
    padding: 33px 36px;

    .textTitle {
      font-size: 20px;
      font-family: Alibaba PuHuiTi;
      font-weight: bold;
      color: #2a2a2a;
    }

    .textBtn {
      font-size: 16px;
      font-family: Alibaba PuHuiTi;
      font-weight: 400;
      color: #252525;
      margin-top: 14px;
    }

    .rightPart {
      width: 33%;
    }

    /deep/ .el-steps {
      .el-step__line-inner {
        border-color: #dbdbdb;
      }

      .el-step__icon {
        color: #fff;
        top: -5px;
        border-width: 5px;
        box-sizing: content-box;
      }

      .is-finish .el-step__icon {
        background: #3bc37b;
        border-color: #bcecd2;
      }

      .is-process .el-step__icon {
        background: #2981ee;
        border-color: #abc9ef;
      }

      .is-wait .el-step__icon {
        background: #a7a7a7;
        border-color: #dbdbdb;
      }

      .el-step__title {
        font-size: 16px;
        font-weight: 540;
      }

      .is-error .el-step__icon {
        background: #f85b4b;
        border-color: #f2c8c3;
      }

      .el-step__title.is-finish {
        //color: #c0c4cc;
        color: #44cb8e;
      }

      .el-step__title.is-process {
        //color: #a7a7a7;
        color: #3498f2;
      }

      .el-step__title.is-wait {
        color: #a7a7a7;
      }

      .el-step__description {
        padding-left: 10px !important;
        padding-right: 10px !important;
        color: #252525;
      }

      .cancelButton {
        color: #fff;
        font-size: 13px;
        padding: 4px 6px;
        background: #2981ee;
        border-radius: 4px;
        width: 30px;
        margin: 4px auto 0;
        cursor: pointer;
      }

      .rejectSpan {
        color: #f85b4b;
      }
    }
  }

  .auditBtn {
    width: 100%;
    padding: 0 122px;
    display: flex;
    height: 110px;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    background: #fff6f5;
    border-radius: 4px;
  }

  .auditDetails {
    height: 486px;
    width: 100%;
    padding: 44px 120px 35px 120px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;

    .leftBox {
      width: 335px;
      height: 100%;
      background-color: #fff;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      box-sizing: border-box;

      .imgSize {
        width: 335px;
        height: 180px;
        background: #fafafa;
        border: 1px dashed #d4d4d7;
        border-radius: 2px;
        margin-top: 7px;
      }
    }

    .rightBox {
      width: 335px;
      height: 100%;
      background-color: #fff;
      box-sizing: border-box;

      .imgSizeid {
        width: 185px;
        height: 105px;
        background: #fafafa;
        border: 1px dashed #d4d4d7;
        border-radius: 2px;
      }

      .imgSize {
        width: 335px;
        height: 180px;
        background: #fafafa;
        border: 1px dashed #d4d4d7;
        border-radius: 2px;
        margin-top: 7px;
      }
    }
  }
}
</style>
